<app-dialog-heading [heading]="'ID Verification'"></app-dialog-heading>

<form [formGroup]="verificationForm">
  <div class="clearfix mb2">
    <div class="col col-12">
      <app-element-input
        [label]="'ID Number'"
        [required]="true"
        [formControlName]="controls.IdNumber"
        [customValidators]="[CustomValidator.idNumberNumeric, CustomValidator.idNumberLength, CustomValidator.idNumberDOB, CustomValidator.idLuhnValidation]"
        [customErrorMessages]="idNumberErrorMessage"
        [cssClasses]="['w-90']">
      </app-element-input>
    </div>
    <div class="col col-12">
      <app-element-input
        [label]="'Last Name'"
        [required]="true"
        [formControlName]="controls.LastName"
        [cssClasses]="['w-90']">
      </app-element-input>
    </div>
  </div>
</form>

<div *ngIf="verificationResponse" class="mt3">
  <mat-card>
    <mat-card-content>
      <div class="property-grid">
        <div *ngFor="let property of verificationDisplayProperties">
          <div class="bold">{{property.name}}</div>
          <div class="flex items-center">
            <span class="mr1">{{property.value}}</span>
            <greydom-status-indicator
              *ngIf="property.showIndicator"
              [fillColor]="getStatusColor(property.status)">
            </greydom-status-indicator>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<mat-dialog-actions align="center" class="dialog-button-container flex">
  <button class="dialog-button"
          mat-raised-button
          color="warn"
          (click)="onClose()">
    Close
  </button>
  <button class="dialog-button"
          mat-raised-button
          color="primary"
          [disabled]="!verificationForm.valid"
          (click)="onClickVerify()">
    Verify
  </button>
</mat-dialog-actions>